import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, Inject, ChangeDetectorRef, Output, EventEmitter, SimpleChanges, OnChanges, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertModalComponent } from '../alert/alert.component';
import * as fromEmailConfiguration from '../../../screens/email-configuration/state/email-configuration.selectors';
import * as EmailConfigurationAction from '../../../screens/email-configuration/state/email-configuration.actions';
import { Store } from '@ngrx/store';
import { MatDialog } from '@angular/material/dialog';
import { LGEDataService } from 'src/commons';
import { ConfirmModalComponent } from '..';


@Component({
    selector: 'email-template-modal',
    templateUrl: './email-template.component.html',
    styleUrls: ['./email-template.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailTemplateModalComponent implements OnInit, OnDestroy, OnChanges {
    @Input('title') title: string;
    @Input('message') message: string;
    @Input('emailTemplateData') emailTemplateData: any;
    @Input('isReadOnly') isReadOnly: boolean;
    @Input('isReadOnlyList') isReadOnlyList: any
    @Output('showEmailTemplateDetail') showEmailTemplateDetail = new EventEmitter<boolean>();


    emailTemplate: FormGroup;
    confirm: any;
    alert: any
    isEditMode: boolean;
    formFields = [
        { name: 'Internal Recipient', value: '{{Recipient}}' },
        { name: 'External Recipient', value: '{{user.first_name}}' },
        { name: "Chris's Signature", value: "<img style='-webkit-user-select: none;' src='https://contributions.lge-ku.com/CCMS/assets/img/Whelan_M_Chris_signature.png'>" },
        { name: 'Date Request', value: '{{DateRequest}}' },
        { name: 'Organization Name (CC/MG)', value: '{{OrganizationName}}' },
        { name: 'Organization Name (External Forms)', value: '{{orgInfo.Name}}' },
        { name: 'Purpose Of Grant', value: '{{PurposeOfGrant}}' },
        { name: 'Project Name', value: '{{projectName}}' },
        { name: 'Request Number', value: '{{RequestNo}}' },
        { name: 'Request Name', value: '{{RequestName}}' },
        { name: 'Total Amount (CC/MG)', value: '{{TotalAmount}}' },
        { name: 'Total Awarded Amount (External Forms)', value: '{{TotalAwardedAmount}}' },
        { name: 'Test Recipient', value: '{{TestRecipient}}' }
    ];

    editorConfig = {
        toolbar: [
            ["bold", "italic", "underline", "strikeThrough", "superscript", "subscript"],
            [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],

            // ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"],
            [{ 'align': [] }],
            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme

            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ["link"],
            ['emoji']
        ]
    };
    // editorConfig = {
    //     editable: true,
    //     spellcheck: false,
    //     height: '14.5rem',
    //     minHeight: '5rem',
    //     placeholder: 'Enter text here...',
    //     translate: 'no',
    //     imageEndPoint: '',
    //     "toolbar": [
    //         ["bold", "italic", "underline", "strikeThrough", "superscript", "subscript"],
    //         ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"],
    //         ["fontName", "fontSize", "color"],
    //         ["link"]
    //     ]
    // };

    constructor(
        private _dataService: LGEDataService,
        private store: Store<fromEmailConfiguration.State>,
        private ref: ChangeDetectorRef,
        private dialog: MatDialog,
        // private dialogRef: MatDialogRef<EmailTemplateModalComponent>,
        private fb: FormBuilder,
        // @Inject(MAT_DIALOG_DATA) private data: any
    ) {
        this.ref.markForCheck();
    }

    ngOnInit() {

        this.createForms();
    }

    createForms(): void {
        this.emailTemplate = this.fb.group({
            emailTemplateId: [null],
            emailTemplateName: ['', [Validators.maxLength(50)]],
            subject: ['', [Validators.maxLength(150)]],
            formFields: [''],
            emailTemplateDescr: [''],
            systemTemplate: [false],
            deleteIt: [false],
            // 'emailTemplateDescription': [''],
        });
        // this.emailTemplate.setValue(this.emailTemplateData);
        this.emailTemplate.get('formFields').valueChanges.subscribe((value) => {
            function handleCopy(e) {
                if (value !== '') {
                    if (value.includes('signature')) {
                        e.clipboardData.setData('text/html', value);
                    } else {
                        e.clipboardData.setData('text/plain', value);
                    }
                    e.preventDefault();
                    document.removeEventListener('copy', handleCopy, true);
                } else {
                    e.clipboardData.setData('text/plain', value);
                    e.preventDefault();
                    document.removeEventListener('copy', handleCopy, true);
                }
            }
            document.addEventListener('copy', handleCopy, true);
            document.execCommand("copy");
        });

    }
    onDone() {
        this.emailTemplate.get('formFields').setValue('');
    }

    public ngOnChanges(changes: SimpleChanges) {
        // console.log(changes);
        if (changes['emailTemplateData'] || changes['isReadOnly'] || changes['isReadOnlyList'] || changes['title'] || changes['message']) {
            this.emailTemplateData = changes['emailTemplateData'].currentValue;
            if (this.emailTemplate === undefined) {
                setTimeout(() => {
                    this.emailTemplate.setValue(this.emailTemplateData);
                });
            } else {
                if (this.emailTemplate.get('emailTemplateDescr').dirty) {
                    this.showConfirm(`Do you want to save change(s) for [${this.emailTemplate.value.emailTemplateName}]?`, '');
                    this.confirm.afterClosed().subscribe(result => {
                        if (result === 'yes') {
                            this.store.dispatch(new EmailConfigurationAction.SubmitEmailTemplate(this.emailTemplate.value));
                        }
                        this.emailTemplate.setValue(this.emailTemplateData);
                        this.emailTemplate.markAsPristine();
                    });
                } else {
                    this.emailTemplate.setValue(this.emailTemplateData);
                    this.emailTemplate.markAsPristine();
                }
            }
        }

    }

    public showAlert(title: string, message: string) {
        this.alert = this.dialog.open(AlertModalComponent, {
            width: '250px',
            disableClose: true,
            data: { title: title, message: message }
        });
    }

    public showConfirm(title: string, message: string) {
        this.confirm = this.dialog.open(ConfirmModalComponent, {
            width: '350px',
            disableClose: false,
            data: { title: title, message: message }
        });
    }

    onSubmit() {
        let isDisabled = this.isReadOnlyList.indexOf((this.emailTemplate.value.emailTemplateName.trim()).toUpperCase()) > -1;
        let isSystemTemplate = this.emailTemplate.value.systemTemplate;
        if (isDisabled && !isSystemTemplate) {
            this.showAlert('Alert!', 'you can not use  "' + this.emailTemplate.value.emailTemplateName + '"  as an Email Template Name as it is used by the system!');
        } else {
            this.showConfirm('Are you sure you want to submit?', '');
            this.confirm.afterClosed().subscribe(result => {
                if (result === 'yes') {
                    this.store.dispatch(new EmailConfigurationAction.SubmitEmailTemplate(this.emailTemplate.value));
                    // this.dialogRef.close(this.emailTemplate.value);
                }
            });
        }
    }

    onCancel() {
        if (this.emailTemplate.dirty) {
            this.showConfirm('Are you sure you want to cancel change(s)?', '');
            this.confirm.afterClosed().subscribe(result => {
                if (result === 'yes') {
                    this.showEmailTemplateDetail.emit(false);
                }
            });
        } else {
            this.showEmailTemplateDetail.emit(false);
        }
    }

    onUpdate() {
        let isDisabled = this.isReadOnlyList.indexOf((this.emailTemplate.value.emailTemplateName.trim()).toUpperCase()) > -1;
        let isSystemTemplate = this.emailTemplate.value.systemTemplate;
        if (isDisabled && !isSystemTemplate) {
            this.showAlert('Alert!', 'you can not use  "' + this.emailTemplate.value.emailTemplateName + '"  as an Email Template Name as it is used by the system!');
        } else {
            this.showConfirm('Are you sure you want to update?', '');
            this.confirm.afterClosed().subscribe(result => {
                if (result === 'yes') {
                    this.store.dispatch(new EmailConfigurationAction.SubmitEmailTemplate(this.emailTemplate.value));
                    // this.dialogRef.close(this.emailTemplate.value);
                }
            });
        }
    }

    onDelete() {
        let isDisabled = this.isReadOnlyList.indexOf((this.emailTemplate.value.emailTemplateName.trim()).toUpperCase()) > -1;
        let isSystemTemplate = this.emailTemplate.value.systemTemplate;
        if (isDisabled && !isSystemTemplate) {
            this.showAlert('Alert!', 'you can not use  "' + this.emailTemplate.value.emailTemplateName + '"  as an Email Template Name as it is used by the system!');
        } else {
            this.showConfirm('Are you sure you want to delete?', '');
            this.confirm.afterClosed().subscribe(result => {
                if (result === 'yes') {
                    this.emailTemplate.value.deleteIt = true;
                    // this.dialogRef.close(this.emailTemplate.value);
                }
            });
        }
    }

    ngOnDestroy() {

    }
}
